var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{staticClass:"pb-2 pt-2 mt-0 px-0",attrs:{"items":_vm.breadCrumbs},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('v-breadcrumbs-item',{staticClass:"text-subtitle-3 crumb-item",attrs:{"to":item.to,"disabled":item.disabled,"exact":""}},[_vm._v(" "+_vm._s(item.text)+" ")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }